var App = App || {};

App.DocumentDelivery = (function ($) {
    "use strict";

    function init() {
        const form = document.getElementById('docDeliveryForm');
        if (!form) {
            console.warn('docDeliveryForm not found');
            return;
        }

       
        prefillDocDelivery();

        function clearValidation($form) {
            $form.find('.field-validation-error').text(''); 
            $form.find('[aria-invalid="true"]').attr('aria-invalid', 'false');
        }

       
        function payloadFrom(formEl) {
            const fd = new FormData(formEl);
            const obj = Object.fromEntries(fd.entries());
           
            obj.RushOrder = String(obj.RushOrder).toLowerCase() === 'true';
            obj.Copyright = String(obj.Copyright).toLowerCase() === 'true';
            
            return obj;
        }

        function getRecaptchaToken() {
            try {
                return (window.grecaptcha && grecaptcha.getResponse()) || "";
            } catch (_) {
                return "";
            }
        }


        form.addEventListener('submit', async (e) => {
            e.preventDefault();
          
            clearValidation($(form));

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                applyValidationMessages($(form));
                
                const firstInvalid = form.querySelector(':invalid');
                if (firstInvalid) {
                    firstInvalid.setAttribute('aria-invalid', 'true');
                    firstInvalid.focus();
                }
                return; 
            }

       

            const token = getRecaptchaToken();
            const recaptchaError = document.getElementById('dd-recaptcha-error');

            if (!token) {
                recaptchaError.textContent = 'Make sure to complete the "I am not a robot" challenge';
                recaptchaError.style.display = 'block'; 
                return;
            } else {
                recaptchaError.textContent = '';
                recaptchaError.style.display = 'none'; 
            }


            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset._orig = submitBtn.value; submitBtn.value = 'Submitting…'; }

          

            try {
                const payload = payloadFrom(form);
                payload.RecaptchaToken = token;
                const res = await fetch('/api/invoice', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                const data = await res.json().catch(() => ({}));
                if (res.ok && (data.success === true || data.Status === 'Success')) {
                    window.location.href = '/research/document-delivery/thank-you/';
                } else {
                    if (window.grecaptcha) grecaptcha.reset();
                    alert((data.message || data.Message || 'Submission failed.'));
                    
                }
            } catch (err) {
                if (window.grecaptcha) grecaptcha.reset();
                console.error(err);
                alert('Unexpected error. Please try again.');
            } finally {
                if (submitBtn) { submitBtn.disabled = false; submitBtn.value = submitBtn.dataset._orig || 'Submit'; }
            }
        });
    }

    async function prefillDocDelivery() {
        try {
            const res = await fetch('/api/document-delivery/prefill', { method: 'GET', credentials: 'same-origin' });
            if (!res.ok) return; 
            const p = await res.json();
            if (!p?.success) return;

           
            const setIfEmpty = (id, val) => {
                const el = document.getElementById(id);
                if (!el) return;
                if (!el.value || el.value.trim().length === 0) el.value = val ?? '';
            };

            setIfEmpty('dd-customer', p.customer);
            setIfEmpty('dd-firm', p.firm);
            setIfEmpty('dd-address', p.address);
            setIfEmpty('dd-phone', p.phone);
            setIfEmpty('dd-fax', p.fax);
            setIfEmpty('dd-email', p.email);

           
            const setHidden = (id, val) => { const el = document.getElementById(id); if (el) el.value = val ?? ''; };
            setHidden('dd-bin', p.bin);
            setHidden('dd-customer-account', p.accountId);
           
        } catch (e) {
            console.warn('Prefill failed', e);
        }
    }
    function applyValidationMessages($form) {
        $form.find(":invalid").each(function () {
            let msg = "";

            switch (true) {
                case this.validity.valueMissing:
                    msg = $(this).data("val-required") || "A value is required.";
                    break;

                case this.validity.typeMismatch:
                    msg = $(this).data("val-type") || "Incorrect format.";
                    break;

                case this.validity.patternMismatch: {
                    const isPhone =
                        (this.name || "").toLowerCase() === "phone" ||
                        (this.id || "").toLowerCase().includes("phone");

                    msg = $(this).data("val-pattern") ||
                        (isPhone ? "Enter a valid phone number." : "Incorrect format.");
                    break;
                }

                default:
                    msg = this.validationMessage || "Invalid value.";
                    break;
            }

            $(this).attr("aria-invalid", "true");
            $(this).siblings(".field-validation-error").text(msg);
        });
    }




    return { init };
})(jQuery);

$(function () {
    App.DocumentDelivery.init();
});
